import { useEffect, useRef } from 'react'
import getTextColor from '../../../utils/getTextColor'
import DesktopDialogWrapper from '../DesktopDialogWrapper'
import CloseIcon from './CloseIcon'
import styles from './Dialog.module.css'

const DesktopDialogEmailCollectionStep = ({ data, onClose, onReject, firstName, setFirstName, lastName, setLastName, email, setEmail, isEmailValid, onSubmit, withOverlay = true, isLoading }) => {
  const firstNameInputRef = useRef(null)

  useEffect(() => {
    if (firstNameInputRef.current) {
      firstNameInputRef.current.focus()
    }
  }, [])

  const brandColor = data?.brandColor
  const popupTitle = data?.popupTitle?.value
  const popupDescription = data?.popupDescription?.value

  return (
    <DesktopDialogWrapper data={data} withOverlay={withOverlay}>
      {withOverlay && <button onClick={onClose} className={styles.closeButton}><CloseIcon fill="gray" /></button>}
      <p className={styles.desktopPopupTitle}>{popupTitle}</p>
      <p className={styles.desktopPopupDescription}>{popupDescription}</p>
      <div className={styles.nameInputRow}>
        <input ref={firstNameInputRef} className={styles.desktopTextInput} type="text" id='firstName' name='firstName' placeholder='First name' value={firstName} onChange={e => setFirstName(e.target.value)} onKeyDown={e => e.key === 'Enter' && !isLoading && onSubmit()} disabled={isLoading} />
        <input className={styles.desktopTextInput} type="text" id='lastName' name='lastName' placeholder='Last name' value={lastName} onChange={e => setLastName(e.target.value)} onKeyDown={e => e.key === 'Enter' && !isLoading && onSubmit()} disabled={isLoading} />
      </div>
      <input className={styles.desktopTextInput} type="email" id='email' name='email' placeholder='Email address (optional)' value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && !isLoading && onSubmit()} disabled={isLoading} />
      {!isEmailValid && 
      <p className={styles.desktopEmailValidationError}>Please enter a valid email address</p>}
      <button onClick={onSubmit} className={styles.desktopCta} style={{ backgroundColor: brandColor }} disabled={isLoading}>
        <p className={styles.desktopCtaMainText} style={{color: getTextColor(brandColor)}}>Continue</p>
      </button>
      <button onClick={onReject} className={styles.noThanksButton}>No thanks</button>
    </DesktopDialogWrapper>

  ) 
}

export default DesktopDialogEmailCollectionStep
